import React from "react";
import Image from "next/image";
import Router from "next/router";
import styled from "styled-components";
import stylesLess from "./index.module.less";
import { getAbsoluteUrl, getOrigin } from "utils/method";
import cookie from "utils/cookie";
import { AppContext } from "contexts/app";
import XtSvg from "components/Xt/Svg";
import LocalesMap from "locales/map";

import imgLogo_dark from "assets/images/saas/beta/logo-dark.png";
import imgLogo_light from "assets/images/saas/beta/logo.png";
import axios from "utils/axios";

export default function Nav() {
  const router = Router.useRouter();
  const [appState, appDispatch] = React.useContext(AppContext);

  const imgLogo = appState.isDark ? imgLogo_dark : imgLogo_light;
  const domain = getOrigin("www");

  const handleThemeToggle = () => {
    // cookie.setDomain("theme", appState.isDark ? "light" : "dark");
    const cls = appState.isDark ? "light" : "dark";
    cookie.set("theme", cls);
    appDispatch({
      payload: {
        isDark: !appState.isDark,
      },
    });
    document.body.className = cls;
  };
  const handleLangChange = (obj) => {
    cookie.set("lang", obj.key);
    axios.instance.defaults.headers.lang = obj.key;
    appDispatch({
      payload: {
        lang: obj.key,
      },
    });
    if (typeof location !== "undefined")
      return (location.href = getAbsoluteUrl({
        pathname: router.asPath,
        locale: obj.name,
        basePath: "",
      }));
    router.push(router.asPath, router.asPath, { locale: obj.name });
  };

  return (
    <div className={`${stylesLess.main} ${appState.isDark ? "dark" : "light"}`}>
      <a href={domain}>
        <img src={imgLogo.src} style={{ height: "32px" }} alt="logo" />
      </a>

      <div className={"iRight"}>
        <button className="btntxt ico" onClick={handleThemeToggle}>
          <XtSvg icon={appState.isDark ? "theme-light" : "theme-dark"} />
        </button>
        <div className={"iDrop"}>
          <button className="btntxt ico">
            <XtSvg icon={"language"} />
          </button>
          <div>
            {LocalesMap.map((item) => {
              return (
                <button
                  key={item.key}
                  className={`iDropLi btntxt ${
                    item.key === appState.lang ? "atv" : ""
                  }`}
                  onClick={() => handleLangChange(item)}
                >
                  {item.lab}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
